import type { BillingProcessor } from "../types";

/**
 * Derives the processor mode ('test' | 'live') from the loaded processor key.
 *
 * Paystack and Polar both use the 'sk_test_' prefix for test keys.
 * All other processors (manual, future) default to 'live'.
 */
export function deriveProcessorMode(
  processor: BillingProcessor,
  key: string
): "test" | "live" {
  if (processor === "paystack" || processor === "polar") {
    return key.startsWith("sk_test_") ? "test" : "live";
  }
  return "live";
}
